module.exports = __webpack_public_path__ + "images/next/recruiting_services/check-76066cb8ae8beeb7b5afa3f24783f5db.png";